

























































































































































































































































































































































































































































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

@Component({})
export default class BulkFieldMapping extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private accountId!: string;
  @Prop() private companyId!: string;
  @Prop() private jobId!: string;

  private inputFields: object = {};
  private inputFieldsAutoMapping: object = {};

  private loading = false;

  private requiredFields = ["title", "itemCode"];
  private finalMappingsToSave = {};
  private errorMessages: string[] = [];
  private errorMessageTop = "";
  private hideIdentifiers = true;

  async mounted() {
    this.getJobDetails();
  }

  toggleIdentifiersView() {
    this.hideIdentifiers = !this.hideIdentifiers;
  }

  @Watch("errorMessages")
  @Watch("errorMessageTop")
  focusErrorAlert() {
    if (this.errorMessages.length > 0) {
      (this.$refs.mappingHeader as any).scrollIntoView();
    }
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (
      error.response &&
      error.response.data &&
      error.response.data.details &&
      error.response.data.details.length > 0
    ) {
      this.$store.commit("recordError", "");
      this.errorMessages = error.response.data.details.map((e) => {
        if (_.has(errorsUtil.specialErrors, e.code))
          return errorsUtil.specialErrors[e.code];
        else return e.message;
      });
    } else if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  areMultipleColumnsSelected(bulkField) {
    return (
      this.finalMappingsToSave[bulkField] &&
      this.finalMappingsToSave[bulkField].fields.length > 1
    );
  }

  joinMethodOptions(bulkField) {
    return ["concat", "coalesce"].map((option) => {
      return {
        label: option,
        value: option,
        selected:
          this.finalMappingsToSave[bulkField] &&
          this.finalMappingsToSave[bulkField].joinType == option,
      };
    });
  }

  joinMethodSelected(e, bulkField) {
    const currentSelections = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: "-",
      fields: currentSelections,
      joinType: e.detail.item.value,
    });
  }

  onSeparatorChange(e, bulkField) {
    const currentSelections = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: e.target.value,
      fields: currentSelections,
      joinType: "concat",
    });
  }

  getJobDetails() {
    this.$api
      .get(`item-classification-api/v1/jobs/${this.companyId}/${this.jobId}`)
      .then((response) => {
        const jobDetails = response.data;
        this.inputFields = jobDetails.inputFields;
        this.inputFieldsAutoMapping = jobDetails.inputFieldsAutoMapping;
        this.finalMappingsToSave = jobDetails.fieldMapping
          ? jobDetails.fieldMapping
          : {};
        this.$store.commit("stopLoading");
        this.loading = false;
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.loading = false;
        this.displayError(error);
      });
  }

  async saveAndNext() {
    this.$store.commit("startLoading");
    const isSuccess = await this.saveMappings();
    if (isSuccess) this.$emit("step-done");
  }

  async saveMappings() {
    const finalMappings = this.nonEmptyMappings(this.finalMappingsToSave);
    try {
      const saveResponse = await this.$api.put(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/schemaNew`,
        finalMappings
      );
      this.$store.commit("stopLoading");
      return true;
    } catch (error) {
      this.displayError(error);
      this.$store.commit("stopLoading");
      return false;
    }
  }

  private singleMappingSelected(e, bulkField) {
    const selectedInputField = e.detail.item.value;
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: "-",
      fields: [selectedInputField],
      joinType: "concat",
    });
  }

  private multiMappingSelected(e, bulkField) {
    const selectedInputField = e.detail.item.value;
    const currentSelections = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: "-",
      fields: currentSelections.concat([selectedInputField]),
      joinType: "concat",
    });
  }

  private multiMappingDeselected(e, bulkField) {
    const selectedInputField = e.detail.item.value;
    const currentSelections = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: "-",
      fields: currentSelections.filter(
        (option) => option != selectedInputField
      ),
      joinType: "concat",
    });
  }

  private getRecommendedField(bulkField: string) {
    if (this.inputFieldsAutoMapping) {
      const recommendedInputField = Object.keys(
        this.inputFieldsAutoMapping
      ).find(
        (inputField) =>
          this.inputFieldsAutoMapping[inputField].recommended === bulkField
      );
      return recommendedInputField || "";
    }
    return "";
  }

  inputFieldOptionsForSingleselect(bulkField) {
    if (!this.inputFields || Object.keys(this.inputFields).length == 0)
      return [];
    const currentSelection: string =
      this.finalMappingsToSave[bulkField] &&
      this.finalMappingsToSave[bulkField].fields.length > 0
        ? this.finalMappingsToSave[bulkField].fields[0]
        : "";
    return [{ label: "", value: "", selected: currentSelection === "" }].concat(
      Object.keys(this.inputFields).map((x) => {
        return {
          label: x,
          value: x,
          selected: currentSelection === x,
        };
      })
    );
  }

  inputFieldOptionsForMultiselect(bulkField) {
    if (!this.inputFields || Object.keys(this.inputFields).length == 0)
      return [];
    const currentSelections: string[] = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    return Object.keys(this.inputFields).map((x: string) => {
      return {
        label: x,
        value: x,
        selected: currentSelections.indexOf(x) >= 0,
      };
    });
  }

  private nonEmptyMappings(mappings: object): object {
    return this.$_.pickBy(
      mappings,
      (x) => !this.$_.isEmpty(x.fields) && x.fields[0] != ""
    );
  }

  private isSavePossible() {
    const finalMappings = this.nonEmptyMappings(this.finalMappingsToSave);
    const finalMappingsCount = Object.keys(finalMappings).length;
    const areRequiredFieldsPopulated = this.requiredFields.every(
      (requiredField) =>
        finalMappings[requiredField] &&
        finalMappings[requiredField].fields.length > 0
    );
    return areRequiredFieldsPopulated && finalMappingsCount > 0;
  }

  private previous() {
    (this.$parent as any).previousStep();
  }

  private cancel() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/jobs`,
    });
  }
}
